import dayjs from '../../../utils/dayjsConfig'
import { buildUnifiedVisitLookupKey } from './buildUnifiedVisitDetails'
import { getCurrentDate } from '../../../helpers/formatDate'
import { downloadCsvRows } from './downloads/exportRouteUserReportFiles'

const ROUTE_TABLE_HEADERS = [
  'Cliente',
  'Fecha planificada',
  'Fecha de ejecución',
  'Duración de visita/atención',
  'Dentro de ruta',
  'Efectividad',
  'Actividades realizadas',
  'Estado'
]

const buildRouteTableCsvRow = (row) => [
  row.clientLabel || '-',
  row.plannedDateLabel || '-',
  row.executedDateLabel || '-',
  row.visitDuration || '-',
  row.inRouteLabel || '-',
  row.effectivenessLabel || '-',
  Array.isArray(row.activities) && row.activities.length ? row.activities.join(', ') : '-',
  row.statusLabel || '-'
]

export const exportRouteExecutionTableCsv = (rows = [], detailsByKey = {}) => {
  if (!rows.length) return

  const detailHeaders = [
    'Fecha y hora',
    'Tipo',
    'Código de actividad',
    'Actividad',
    'Motivo/Descripción',
    'Monto',
    'Dentro de geocerca'
  ]
  const csvRows = [
    [...ROUTE_TABLE_HEADERS, ...detailHeaders],
    ...rows.flatMap((row) => {
      const details = detailsByKey?.[buildUnifiedVisitLookupKey(row.rawRow || row)] || []
      const main = buildRouteTableCsvRow(row)
      return details.length
        ? details.map((detail) => [
            ...main,
            detail.datetime ? dayjs(detail.datetime).format('DD/MM/YYYY HH:mm:ss') : '-',
            { check_in: 'Check-In', check_out: 'Check-Out', activity: 'Actividad' }[detail.type] ||
              'Detalle',
            detail.activityCode || '-',
            detail.label || '-',
            detail.description || '-',
            detail.amount ?? '-',
            detail.inGeofence || 'N/A'
          ])
        : [[...main, ...detailHeaders.map(() => '-')]]
    })
  ]
  downloadCsvRows(csvRows, `Visitas_EjecucionPlan_${getCurrentDate()}.csv`)
}
